import { THealthDomain, THealthDomainScores, THealthSubDomain } from './Health.types';

export type TDashboardTrend = Record<
  THealthDomain | 'totalScore',
  { month: number; year: number; score: number | null }[]
>;

export enum WHOLENESS_TREND {
  IMPROVING = 'IMPROVING',
  DECLINING = 'DECLINING',
}

export type TDashboardInsights = {
  perDomain: {
    improving: Record<THealthDomain, number>;
    declining: Record<THealthDomain, number>;
    combined: {
      trend: WHOLENESS_TREND;
      value: number;
      time: string; // TODO: BE needs to add some string for relative time
    };
  };
  perDomainSubdomains: Record<
    THealthDomain,
    {
      improving: Record<THealthSubDomain, number>;
      declining: Record<THealthSubDomain, number>;
      combined: { trend: WHOLENESS_TREND; value: number };
      immediateAttention: Record<THealthSubDomain, number>;
      developingPotential: Record<THealthSubDomain, number>;
    }
  >;
};

export type TDashboardScores = {
  totalScore: number;
  domains: THealthDomainScores;
  createdAt: string;
};
